import axios from 'axios';
import { attachPostHogCorrelationHeaders } from './posthog-correlation-headers';

export const apiClient = axios.create({
    withCredentials: true,
    withXSRFToken: true,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    },
});

apiClient.interceptors.request.use((config) => {
    const requestId =
        typeof crypto !== 'undefined' && 'randomUUID' in crypto ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

    config.headers.set('X-Request-Id', requestId);

    if (import.meta.env.VITE_POSTHOG_KEY) {
        attachPostHogCorrelationHeaders(config);
    }

    return config;
});
